import React from 'react';
import { Tile, Button } from '@Components/common';
import { Fund, FundStatusEnum } from '@Types';
import { useTranslation } from 'react-i18next';
import { FundName } from '@Components/Funds/Components/FundName';
import { OrganizationAvatar } from '@Components/OrganizationAvatar/OrganizationAvatar';
import styles from './NominationLandingPage.module.scss';
import { formatDate } from '@Helpers/formatDate';
import { RiCalendar2Fill } from 'react-icons/ri';

export interface FundWithNominationUrl extends Fund {
  nomination_form_url: string;
}

interface NominationLandingPageProps {
  funds: FundWithNominationUrl[];
}

export const NominationLandingPage = ({ funds = [] }: NominationLandingPageProps) => {
  const { t } = useTranslation('fund');

  return (
    <div className={styles.tileContainer}>
      <div className={styles.headerSection}>
        <OrganizationAvatar avatarImage={funds[0]?.funding_profile?.avatar_image} size="medium" />
        <h1>{t('nomination.landing_page.heading')}</h1>
        <p className={styles.description}>{t('nomination.landing_page.description')}</p>
      </div>
      <div className={styles.container}>
        {funds.map((fund) => {
          const { id, status, details } = fund;
          const { deadline_to } = details;

          return (
            <Tile key={fund.id} className={styles.fundContainer}>
              <>
                <div className={styles.fundHeader}>
                  <OrganizationAvatar
                    avatarImage={fund.funding_profile.avatar_image}
                    size="small"
                  />
                  <FundName name={fund.details.name} status={status} />
                </div>
                <div className={styles.infoContainer}>
                  <div className={styles.deadlineContainer}>
                    <RiCalendar2Fill size={14} />
                    <span>
                      {t('details_page.date_progress.DURING')} {formatDate(deadline_to)}
                    </span>
                  </div>
                  {fund.nomination_form_url && (
                    <Button size="small" buttonType="secondary" to={fund.nomination_form_url}>
                      {t('nomination.landing_page.nominate')}
                    </Button>
                  )}
                </div>
              </>
            </Tile>
          );
        })}
      </div>
    </div>
  );
};
